export const newName = (data) => {
  const name = data.split(".").shift();
  return name;
};
